export default function getResource(label, vars = []) {
    const resources = {
        copy: `You’re saving an additional <b>${vars[0]}</b> with <b>${vars[1]}</b>. Valid on eligible Auto‑Replenish subscription orders scheduled to ship between <b>${vars[2]}</b> and <b>${vars[3]}</b>.`
    };

    return resources[label];
}
